import React from 'react';

const ChevronLeft: React.FC = () => {
  return (
    <svg
      fill="none"
      height="34"
      viewBox="0 0 34 34"
      width="34"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5851 7.49831C17.1384 8.05155 17.1384 8.94853 16.5851 9.50178L10.5036 15.5834H26.9167C27.6992 15.5834 28.3334 16.2176 28.3334 17C28.3334 17.7824 27.6992 18.4167 26.9167 18.4167H10.5036L16.5851 24.4983C17.1384 25.0515 17.1384 25.9485 16.5851 26.5018C16.0319 27.055 15.1349 27.055 14.5817 26.5018L6.08168 18.0018C5.816 17.7361 5.66675 17.3758 5.66675 17C5.66675 16.6243 5.816 16.264 6.08168 15.9983L14.5817 7.49831C15.1349 6.94506 16.0319 6.94506 16.5851 7.49831Z"
        fill="white"
      />
    </svg>
  );
};

export default ChevronLeft;
